<ng-container *ngIf="( expiracionClave$ | async ) as expiracionClave; else loading">
	<div [ngStyle]="messageStyle$ | async">
		Tu contraseña

		<ng-container *ngIf="expiracionClave.dias >= 1">
			vence
			<ng-container *ngIf="expiracionClave.dias == 1"> mañana</ng-container>
			<ng-container *ngIf="expiracionClave.dias > 1"> en {{expiracionClave.dias}}</ng-container>
		</ng-container>

		<ng-container *ngIf="expiracionClave.dias < 1">
			<ng-container *ngIf="expiracionClave.dias == 0"> vence hoy</ng-container>
			<ng-container *ngIf="expiracionClave.dias < 0">
				venció
				<ng-container *ngIf="expiracionClave.dias == -1"> ayer</ng-container>
				<ng-container *ngIf="expiracionClave.dias < -1"> hace {{-expiracionClave.dias}}</ng-container>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="( expiracionClave.dias >= 0? expiracionClave.dias: -expiracionClave.dias ) as dias">
			<ng-container *ngIf="dias > 1"> días</ng-container>
		</ng-container>

		({{expiracionClave.fechaExpiracionAsDesc}})
	</div>
</ng-container>

<!-- Cargando -->
<ng-template #loading>
	<loading></loading>
</ng-template>